import { styled, Tooltip, TooltipProps } from '@mui/material';
import { ReactNode } from 'react';
import { InformationCircleIcon } from '@heroicons/react/24/outline';
import { DEFAULT_ICON_WIDTH } from '@constants';

interface TooltipIconProps {
  title: ReactNode;
  iconWidth?: number;
  placement?: TooltipProps['placement'];
  disablePortal?: boolean;
}

const TooltipIcon = ({ title, iconWidth = DEFAULT_ICON_WIDTH, placement = 'top', disablePortal }: TooltipIconProps) => {
  const StyledIcon = styled(InformationCircleIcon)(({ theme: { palette } }) => ({
    color: palette.mode === 'dark' ? '#FFFFFF8F' : '#00172E8F',
  }));

  return (
    <Tooltip
      arrow
      title={typeof title === 'string' ? <span dangerouslySetInnerHTML={{ __html: title }} /> : title}
      placement={placement}
      PopperProps={{
        disablePortal,
      }}
    >
      <StyledIcon width={iconWidth} />
    </Tooltip>
  );
};

export default TooltipIcon;
